// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

export const ColorSwatchesWrapper = styled.ul`
  display: flex;
  align-items: center;
  width: fit-content;
  column-gap: 8px;
  box-sizing: border-box;

  &,
  li {
    height: 16px;
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 20px;
    }
  }

  li {
    display: flex;
    align-items: center;
  }
`;

export const ColorChipButton = styled.button`
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  padding: 0;
  border: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
  border-radius: 50%;
  cursor: pointer;
  background: ${(props) => `url(${props.imageUrl})`} no-repeat center;
  background-size: contain;

  @media ${(props) => props.theme.mediaQuery.large} {
    width: 20px;
    height: 20px;
  }
`;

export const ColorChipTextButton = styled(ColorChipButton)`
  width: auto;
  height: auto;
  vertical-align: top;
  border-radius: unset;
  border: unset;
`;

export const ColorChipText = styled(BodyCopy)`
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  color: ${(props) => props.theme.colorPalette.gray[800]};

  @media ${(props) => props.theme.mediaQuery.large} {
    font-size: 12px;
    line-height: 16px;
  }
`;
